import { filter, isEmpty, pick, split } from 'lodash'

const transformToUpdateFoodMoodSimpleDetailsArgs = data => ({
  ...pick(data, [
    'description',
    'position',
    'synonyms',
    'isExcludedFromSearch',
    'isExcludedFromBrowsing',
  ]),
  synonyms: filter(split(data.synonyms, '\n'), synonym => !isEmpty(synonym)),
})

export default transformToUpdateFoodMoodSimpleDetailsArgs
